import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-security-type-flags",
  // imports: [],
  templateUrl: "./security-type-flags.component.html",
  styleUrl: "./security-type-flags.component.css",
  standalone: false,
})
export class SecurityTypeFlagsComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
